const TEAM_NAME_TO_COUNTRY_CODE = {
  argentina: "AR",
  algeria: "DZ",
  australia: "AU",
  austria: "AT",
  belgium: "BE",
  bolivia: "BO",
  bosnia: "BA",
  "bosnia and herzegovina": "BA",
  "bosnia-herzegovina": "BA",
  brazil: "BR",
  canada: "CA",
  "cape verde": "CV",
  "cape verde islands": "CV",
  chile: "CL",
  china: "CN",
  colombia: "CO",
  croatia: "HR",
  czechia: "CZ",
  chequia: "CZ",
  "czech republic": "CZ",
  denmark: "DK",
  ecuador: "EC",
  egypt: "EG",
  england: "GB",
  jordan: "JO",
  france: "FR",
  germany: "DE",
  ghana: "GH",
  "ivory coast": "CI",
  "costa de marfil": "CI",
  holland: "NL",
  hungary: "HU",
  iran: "IR",
  iraq: "IQ",
  italy: "IT",
  japan: "JP",
  mexico: "MX",
  morocco: "MA",
  netherlands: "NL",
  "new zealand": "NZ",
  nigeria: "NG",
  norway: "NO",
  panama: "PA",
  paraguay: "PY",
  peru: "PE",
  poland: "PL",
  portugal: "PT",
  qatar: "QA",
  romania: "RO",
  russia: "RU",
  saudiarabia: "SA",
  "saudi arabia": "SA",
  scotland: "GB",
  senegal: "SN",
  serbia: "RS",
  "south africa": "ZA",
  "south korea": "KR",
  spain: "ES",
  sweden: "SE",
  switzerland: "CH",
  tunisia: "TN",
  turkey: "TR",
  uruguay: "UY",
  usa: "US",
  "united states": "US",
  "united states of america": "US",
  wales: "GB",
};

const TEAM_NAME_TO_SPANISH_LABEL = {
  argentina: "Argentina",
  algeria: "Argelia",
  australia: "Australia",
  austria: "Austria",
  belgium: "Bélgica",
  bolivia: "Bolivia",
  bosnia: "Bosnia y Herzegovina",
  "bosnia and herzegovina": "Bosnia y Herzegovina",
  "bosnia-herzegovina": "Bosnia y Herzegovina",
  brazil: "Brasil",
  canada: "Canadá",
  "cape verde": "Cabo Verde",
  "cabo verde": "Cabo Verde",
  "cape verde islands": "Islas de Cabo Verde",
  chile: "Chile",
  china: "China",
  colombia: "Colombia",
  croatia: "Croacia",
  czechia: "República Checa",
  chequia: "República Checa",
  "czech republic": "República Checa",
  denmark: "Dinamarca",
  ecuador: "Ecuador",
  egypt: "Egipto",
  england: "Inglaterra",
  jordan: "Jordania",
  france: "Francia",
  germany: "Alemania",
  ghana: "Ghana",
  "ivory coast": "Costa de Marfil",
  "costa de marfil": "Costa de Marfil",
  holland: "Países Bajos",
  hungary: "Hungría",
  iran: "Irán",
  iraq: "Irak",
  italy: "Italia",
  japan: "Japón",
  mexico: "México",
  morocco: "Marruecos",
  netherlands: "Países Bajos",
  "new zealand": "Nueva Zelanda",
  nigeria: "Nigeria",
  norway: "Noruega",
  panama: "Panamá",
  paraguay: "Paraguay",
  peru: "Perú",
  poland: "Polonia",
  portugal: "Portugal",
  qatar: "Catar",
  romania: "Rumania",
  russia: "Rusia",
  saudiarabia: "Arabia Saudita",
  "saudi arabia": "Arabia Saudita",
  scotland: "Escocia",
  senegal: "Senegal",
  serbia: "Serbia",
  "south africa": "Sudáfrica",
  "south korea": "Corea del Sur",
  spain: "España",
  sweden: "Suecia",
  switzerland: "Suiza",
  tunisia: "Túnez",
  turkey: "Turquía",
  uruguay: "Uruguay",
  usa: "Estados Unidos",
  "united states": "Estados Unidos",
  "united states of america": "Estados Unidos",
  wales: "Gales",
};

function normalizeTeamName(teamName) {
  return String(teamName || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

function countryCodeToFlagEmoji(countryCode) {
  const code = String(countryCode || "").trim().toUpperCase();

  if (!/^[A-Z]{2}$/.test(code)) {
    return "";
  }

  return String.fromCodePoint(
    ...Array.from(code, (char) => 127397 + char.charCodeAt(0)),
  );
}

export function getTeamFlagEmoji(teamName) {
  const normalizedName = normalizeTeamName(teamName);
  const countryCode = TEAM_NAME_TO_COUNTRY_CODE[normalizedName];

  if (!countryCode) {
    return "";
  }

  return countryCodeToFlagEmoji(countryCode);
}

export function getTeamDisplayName(teamName) {
  const normalizedName = normalizeTeamName(teamName);
  return TEAM_NAME_TO_SPANISH_LABEL[normalizedName] ?? String(teamName || "").trim();
}
